<div class="px-4 mt-24">
  <div class="max-w-md w-full mx-auto">
    <!-- GET USERNAME -->
    @if (currentSection === 1) {
      <div>
        <!-- Header -->
        <div class="text-center mb-8">
          <h1 class="text-4xl font-bold text-base-content">Reset Password</h1>
          <p class="text-base-content/70 mt-2">Reset your account password</p>
        </div>
        <!-- Card -->
        <div class="daisy-card bg-base-100 shadow-xl">
          <div class="daisy-card-body">
            <form [formGroup]="userNameInputForm" class="space-y-4">
              <!-- Username Field -->
              <div class="daisy-form-control w-full">
                <label class="daisy-label">
                  <span class="daisy-label-text">Username</span>
                </label>
                <input
                  type="text"
                  formControlName="username"
                  placeholder="Email Address or Mobile Number"
                  class="daisy-input daisy-input-bordered w-full"
                [ngClass]="{
                  'daisy-input-error':
                    userNameInputForm.invalid &&
                    (usernameInput?.dirty || usernameInput?.touched)
                }"
                  />
                  @if (
                    userNameInputForm.invalid &&
                    (usernameInput?.dirty || usernameInput?.touched)
                    ) {
                    <div
                      class="daisy-label mt-1"
                      >
                      @if (usernameInput?.hasError('required')) {
                        <span
                          class="daisy-label-text-alt text-error"
                          >
                          Username is required
                        </span>
                      }
                      @if (usernameInput?.hasError('emailPhone')) {
                        <span
                          class="daisy-label-text-alt text-error"
                          >
                          Username should be valid email or mobile number
                        </span>
                      }
                    </div>
                  }
                </div>
                <!-- Submit Button -->
                <button
                  (click)="intiateResetRequest()"
                  [disabled]="!isInputValid"
                  class="daisy-btn daisy-btn-primary w-full mt-6"
                  >
                  Reset Password
                </button>
              </form>
            </div>
          </div>
        </div>
      }

      <!-- VERIFY CODE -->
      @if (currentSection === 2) {
        <div>
          <black-verify-otp
            [username]="username"
            (otpReady)="sendTokenRequest($event.code)"
            (sendCodeEvent)="sendCodeRequest()"
          ></black-verify-otp>
        </div>
      }

      <!-- RESET PASSWORD -->
      @if (currentSection === 3) {
        <div>
          <!-- Header -->
          <div class="text-center mb-8">
            <h1 class="text-4xl font-bold text-base-content">Reset Password</h1>
            <p class="text-base-content/70 mt-2">Set your new password</p>
          </div>
          <!-- Card -->
          <div class="daisy-card bg-base-100 shadow-xl">
            <div class="daisy-card-body">
              <form [formGroup]="changePasswordForm" class="space-y-4">
                <!-- Password Field -->
                <div class="daisy-form-control w-full">
                  <label class="daisy-label">
                    <span class="daisy-label-text">Password</span>
                  </label>
                  <div class="relative">
                    <input
                      [type]="showPassword ? 'text' : 'password'"
                      formControlName="password"
                      placeholder="Password"
                      class="daisy-input daisy-input-bordered w-full pr-10"
                  [ngClass]="{
                    'daisy-input-error':
                      passwordInput?.invalid &&
                      (passwordInput?.dirty || passwordInput?.touched)
                  }"
                      />
                    <button
                      type="button"
                      (click)="showPassword = !showPassword"
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-base-content/50 hover:text-base-content focus:outline-none"
                      [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                    >
                      <i [class]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                    </button>
                  </div>
                  @if (
                    passwordInput?.invalid &&
                    (passwordInput?.dirty || passwordInput?.touched)
                    ) {
                    <div
                      class="daisy-label mt-1"
                      >
                      @if (passwordInput?.hasError('required')) {
                        <span
                          class="daisy-label-text-alt text-error"
                          >
                          Password is required
                        </span>
                      }
                      @if (passwordInput?.hasError('pattern')) {
                        <div class="daisy-alert daisy-alert-warning mt-2 text-sm">
                          <div>
                            Your password should contain:
                            <ul class="list-disc list-inside mt-1">
                              <li>At least one lowercase character</li>
                              <li>At least one uppercase character</li>
                              <li>At least one digit</li>
                              <li>Minimum length of 8 characters</li>
                            </ul>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <!-- Confirm Password Field -->
                <div class="daisy-form-control w-full">
                  <label class="daisy-label">
                    <span class="daisy-label-text">Confirm Password</span>
                  </label>
                  <div class="relative">
                    <input
                      [type]="showConfirmPassword ? 'text' : 'password'"
                      formControlName="confirm_password"
                      placeholder="Confirm Password"
                      class="daisy-input daisy-input-bordered w-full pr-10"
                  [ngClass]="{
                    'daisy-input-error':
                      changePasswordForm.invalid &&
                      (confirmPasswordInput?.dirty ||
                        confirmPasswordInput?.touched)
                  }"
                      />
                    <button
                      type="button"
                      (click)="showConfirmPassword = !showConfirmPassword"
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-base-content/50 hover:text-base-content focus:outline-none"
                      [attr.aria-label]="showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'"
                    >
                      <i [class]="showConfirmPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                    </button>
                  </div>
                      @if (
                        changePasswordForm.invalid &&
                        (confirmPasswordInput?.dirty || confirmPasswordInput?.touched)
                        ) {
                        <div
                          class="daisy-label mt-1"
                          >
                          @if (changePasswordForm.hasError('confirmPasswordInvalid')) {
                            <span
                              class="daisy-label-text-alt text-error"
                              >
                              Passwords should match
                            </span>
                          }
                        </div>
                      }
                    </div>
                    <!-- Submit Button -->
                    <button
                      (click)="sendResetPasswordRequest()"
                      [disabled]="!changePasswordForm.valid"
                      class="daisy-btn daisy-btn-primary w-full mt-6"
                      >
                      Reset Password
                    </button>
                  </form>
                </div>
              </div>
            </div>
          }

          <!-- SHOW SUCCESS -->
          @if (currentSection === 4) {
            <div>
              <!-- Card -->
              <div class="daisy-card bg-base-100 shadow-xl">
                <div class="daisy-card-body text-center">
                  <iframe
                    frameborder="0"
                    src="https://lottie.host/embed/3c46091d-405c-494f-aa32-867bc7bea62b/7ojwKXeAjH.json"
                    class="mx-auto"
                  ></iframe>
                  <h3 class="text-2xl font-bold text-base-content mt-4">
                    Password reset successful!
                  </h3>
                  <button
                    class="daisy-btn daisy-btn-primary mt-6"
                    routerLink="/auth/login"
                    >
                    Continue to Login
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
